import { ReactElement, useMemo } from 'react';
import { useListConfigurationGroupsQuery } from '@casops/store/apis/configurationGroupsApi';
import { EmptyCell } from '../../formatters/genericFormatters';
import { RegisteredAssetModel } from '@casops/store/apis/registeredAssetsApi';

type ConfigurationGroupIdCellRendererProps = {
  value: number;
  data: RegisteredAssetModel;
};

export function ConfigurationGroupIdCellRenderer({
  value,
  data,
}: ConfigurationGroupIdCellRendererProps): ReactElement | string {
  const { data: configurationGroups } = useListConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const configurationGroupName = useMemo<string>(() => {
    if (!configurationGroups || data.hw === 'PPU') {
      return '';
    }
    const match = configurationGroups.find(g => g.id === value);
    return match ? match.name : '';
  }, [value, configurationGroups, data.hw]);

  return !configurationGroupName.length ? EmptyCell : <span>{configurationGroupName}</span>;
}

export default ConfigurationGroupIdCellRenderer;
